import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Home from "./Home";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Public affiliate landing: /:codigo
 * - Verifies the code exists → renders Home with brand context
 * - If not, redirects to home root "/"
 *
 * The brand is cached on window so the rest of the app (forms, banner)
 * picks it up transparently via useBranding().
 */
export default function AffiliateLink() {
  const { codigo } = useParams();
  const nav = useNavigate();
  const [state, setState] = useState("resolving"); // resolving | ok | notfound

  useEffect(() => {
    // Persist the code in the URL query for the rest of the session,
    // so useBranding() picks it up consistently (also survives client-side nav).
    try {
      const url = new URL(window.location.href);
      if (!url.searchParams.get("partner")) {
        url.searchParams.set("partner", codigo.toLowerCase());
        window.history.replaceState({}, "", url.toString());
      }
    } catch { /* ignore */ }

    axios.get(`${API}/afiliados/resolve/${encodeURIComponent(codigo)}`)
      .then(() => setState("ok"))
      .catch(() => {
        setState("notfound");
        nav("/", { replace: true });
      });
  }, [codigo, nav]);

  if (state === "resolving") {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--bg-soft)" }}>
        <div className="text-[13px]" style={{ color: "var(--text-muted)" }}>Cargando…</div>
      </div>
    );
  }
  if (state === "notfound") return null;
  return <Home />;
}
